exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.commentTransition-enter-active, .commentTransition-leave-active {\n    transition: all 0.2s;\n}\n.commentTransition-enter, .commentTransition-leave-to {\n    opacity: 0;\n}\n\n", ""]);

// exports
